<template>
    <div style="height:90vh;">
        <el-tabs v-model="activeName" type="border-card" @tab-click="getBannerNews(activeName)">
            <!--  v-if="(item.isLogin && access_token) ||  !item.isLogin" -->
            <template v-for="(item, index) in newsList">
                <el-tab-pane :label="item.name" :name="item.value">
                </el-tab-pane>
            </template>
            
        </el-tabs>
        <purchase-table :list="purchase" :hideHeader="false" v-if="activeName == '1'" />
        <correct-table :list="correct" :hideHeader="false" v-if="activeName == '2'" />
        <result-table :list="list" :hideHeader="false" v-if="activeName == '3'" />
        <prequalification :list="prequalificationList" :hideHeader="false" v-if="activeName == '4'" />
        <inquiry :list="inquiryList" :hideHeader="false" v-if="activeName == '5'" />
        <inquiry-result  :list="inquiryResultList" :hideHeader="false" v-if="activeName == '6'" />
        <other :list="otherList" :hideHeader="false" v-if="activeName == '-1'" />
        <member-purchase :hideHeader="false" v-if="activeName == '7'" />
        <div style="margin-top: 20px;text-align: center;">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="query.page" :page-sizes="[1,10, 20, 30, 40, 50, 100]" :page-size="10"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import announcement from "@/api/announcement/announcement"
import purchaseTable from "../components/purchaseTable";
import correctTable from "../components/correctTable";
import resultTable from "../components/resultTable";
import memberPurchase from "../components/memberPurchase";
import prequalification from "../components/prequalification.vue";
import inquiry from "../components/inquiry.vue";
import inquiryResult from "../components/inquiryResult.vue";
import other from "../components/other.vue";
export default {
    components: {
        purchaseTable,
        correctTable,
        resultTable,
        memberPurchase,
        prequalification,
        inquiry,
        inquiryResult,
        other
    },
    data() {
        return {
            query: {
                page: 1,
                limit: 10,
            },
            newsList: [
            // {
            //     name: '采购公告',
            //     value: '1'
            // }, {
            //     name: '更正公告',
            //     value: '2'
            // }, {
            //     name: '结果公告',
            //     value: '3'
            // }, {
            //     name: '资格预审公告',
            //     value: '4'
            // }, 
            {
                name: '采购公告',
                value: '5',
                isLogin:true,
            }, {
                name: '采购结果公告',
                value: '6',
                isLogin:false
            },
            // {
            //     name: '其它公告',
            //     value: '-1'
            // }, 
            // {
            //     name: '会员购买',
            //     value: '7'
            // },
        ],
            access_token:`${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
            activeName: '5',//`${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`?'5':'6',
            nowActiveName: '1',
            nowActiveName1: '1',
            purchase: [], //采购公告
            correct: [], //更正公告
            list: [], //结果公告,
            total: 0,
            suiteList: [],//套餐列表
            prequalificationList: [],//资格预审公告
            inquiryList: [],//询价竞价公告
            inquiryResultList: [],//询价竞价结果公告
            otherList:[],//其它公告
        };
    },

    mounted() {
        // this.getBannerNews(1);
        // this.activeName =  localStorage.getItem('TencentNews')
        // console.log('返回上一页之后的浏览',this.activeName);
    },
    created() {
        // this.activeName =  localStorage.getItem('TencentNews')
         this.handleSizeChange(this.activeName);
         window.scrollTo(0,0)
       


    },

    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.query.limit = val
            if (this.activeName == 1) {
                this.queryBulletinList()
            }
            if (this.activeName == 2) {
                this.correctBulletinList()
            }
            if (this.activeName == 3) {
                this.listBulletinList()
            }
            if (this.activeName == 4) {
                this.getPrequalificationList()
            }
            if (this.activeName == 5) {
                this.getInquiryList()
            }
            if (this.activeName == 6) {
                this.resultPage()
            }
            if (this.activeName == 7) {
                this.querySuiteList()
            }
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.query.page = val
            if (this.activeName == 1) {
                this.queryBulletinList()
            }
            if (this.activeName == 2) {
                this.correctBulletinList()
            }
            if (this.activeName == 3) {
                this.listBulletinList()
            }
            if (this.activeName == 4) {
                this.getPrequalificationList()
            }
            if (this.activeName == 5) {
                this.getInquiryList()

            }
            if (this.activeName == 6) {
                this.getPrequalificationList()
            }
            if (this.activeName == 7) {
                this.resultPage()
            }
        },
        // 切换tab
        getBannerNews(type) {
            // console.log(type, '点击切换之后的type');
            console.log("asaaa",type,this.activeName)
            localStorage.setItem("TencentNews", type);

            this.query.page = 1
            switch (type) {
                case '1':
                    this.queryBulletinList()
                    break;
                case '2':
                    this.correctBulletinList()
                    break;
                case '3':
                    this.listBulletinList()
                    break;
                case '4':
                    this.getPrequalificationList()
                    break;
                case '5':
                    this.getInquiryList()
                    break;
                case '6':
                    this.resultPage()
                    break;
                    
                case '7':
                    this.querySuiteList()
                    break;
                case '-1':
                    this.othertPage()
                    break;
                default:
                    break;
            }
        },
        // 竞价询价公告
        getInquiryList() {
            console.log("sazasxsds",this.activeName)
            announcement.queryPriceList({
                page: 1,
                limit: 10,
                type: 10,
                ...this.query
            }).then(res => {
                if (res.code == 0) {
                    this.inquiryList = res.data.list;
                    this.total = res.data.count
                    this.inquiryList.filter(item => {
                        if (item.status == 0) {
                            item.signTypeName = "未开始"
                        } else if (item.status == 1) {
                            item.signTypeName = "报名中"
                        } else if (item.status == 2) {
                            item.signTypeName = "已结束"
                        }
                    })
                }
            })
        },
        // 资格预审公告列表（最新）
        getPrequalificationList() {
            announcement.queryBulletinList({
                type: 1,
                page: 1,
                limit: 10,
                ...this.query
            }).then(res => {
                if (res.code == 0) {
                    this.prequalificationList = res.data.list;
                    this.total = res.data.count
                }
            })
        },

        //其它公告
        othertPage() {
            announcement.resultPage({
                page: 1,
                limit: 10,
                type: '-1',
                ...this.query
            }).then(res => {
                // console.log(res, 'res');
                this.otherList = []
                this.total = 0
            })
        },
        // 会员购买
        querySuiteList(projectName) {
            announcement.suiteList(this.query).then(
                res => {
                    // console.log("结果公告", res.data);
                    this.suiteList = res.data
                    this.total = res.data.count
                }
            )
        },
        // 询价竞价结果公告
        resultPage() {
            announcement.resultPage({
                page: 1,
                limit: 10,
                type: 11,
                ...this.query
            }).then(res => {
                // console.log(res, 'res');
                this.inquiryResultList = res.data.list
                this.total = res.data.count
            })
        },
        // 公告列表采购公告（最新）
        queryBulletinList() {
            announcement.queryBulletinList({
                type: 2,
                page: 1,
                size: 10,
                ...this.query
            }).then(res => {
                if (res.code == 0) {
                    this.purchase = res.data.list;
                    this.total = res.data.count
                    this.purchase.filter(item => {
                        if (item.status == 0) {
                            item.signTypeName = "已结束"
                        } else if (item.status == 1) {
                            item.signTypeName = "报名中"
                        } else if (item.signType == 3) {
                            item.signTypeName = "已结束"
                        }
                    })
                }
            })
        },

        // 公告列表更正公告（最新）
        correctBulletinList() {
            announcement.queryBulletinList({
                type: 3,
                page: 1,
                size: 10,
                ...this.query
            }).then(res => {
                if (res.code == 0) {
                    this.correct = res.data.list;
                    this.total = res.data.count
                }
            })
        },

        // 公告列表结果公告（最新）
        listBulletinList() {
            announcement.queryBulletinList({
                type: 4,
                page: 1,
                size: 10,
                ...this.query
            }).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list;
                    this.total = res.data.count
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped></style>